import React from 'react'

import { useTranslation } from 'react-i18next'

import Dialog from '@components/shared/Dialog'
import ImagePicker from '@components/shared/ImagePicker/index'

interface Props {
  onComplete: (url: string, blurHash: string | null) => Promise<void>
}
const ImagePickerDialog: React.FC<Props> = (props) => {
  const { t } = useTranslation()
  return (
    <Dialog name="image_picker" title={t('action.searchForImages')} maxWidth={800}>
      <ImagePicker {...props} />
    </Dialog>
  )
}

export default ImagePickerDialog
